import moment from 'moment'

export default class CalendarScheduleModel {
  constructor () {
    this.id = ''
    this.calendarId = 'CUSTOMER'
    this.title = ''
    this.category = 'time'
    this.dueDateClass = ''
    this.start = moment().format()
    this.end = moment().format()
    this.length = 0
    this.isAllDay = true
    this.bgColor = ''
    this.borderColor = ''
    this.color = 'white'
    this.state = 'busy'
    this.isReadOnly = true
    this.raw = {
      status: '',
      reservationCard: undefined,
      bookingCard: undefined,
      numberOfAcceptCandidates: 0,
      packageInfo: false,
      pck: '',
      paid: false,
      recurring: false,
      recurringActive: false,
      recurringLabel: '',
      paymentCard: '',
      paymentDate: '',
      nextPaid: false,
      nextPaymentCard: '',
      nextPaymentDate: '',
      nextRecurringLabel: '',
      nextStartDate: '',
      nextCreated: '',
      showSubscriptionDetail: false,
      customerType: '',
      clipboardReservation: '',
      clipboardBooking: '',
    }
  }

  static fromCalendar (calendar) {
    return createDateRangeFromDates(calendar.dates)
      .map((date) => {
        const calendarScheduleItem = new CalendarScheduleModel()

        calendarScheduleItem.id = calendar.reservation.id
        calendarScheduleItem.calendarId = calendar.reservation.patientId
        calendarScheduleItem.start = date.start
        calendarScheduleItem.end = date.end
        calendarScheduleItem.title = calendar.label
        calendarScheduleItem.raw.status = calendar.status
        calendarScheduleItem.raw.reservationCard = calendar.reservationCard
        calendarScheduleItem.raw.packageInfo = calendar.packageInfo
        calendarScheduleItem.raw.pck = calendar.reservation.price.package
        calendarScheduleItem.raw.paid = calendar.paid
        calendarScheduleItem.raw.recurring = calendar.recurring
        calendarScheduleItem.raw.recurringActive = calendar.recurringActive
        calendarScheduleItem.raw.recurringLabel = calendar.recurringLabel
        calendarScheduleItem.raw.paymentCard = calendar.paymentCard
        calendarScheduleItem.raw.paymentDate = calendar.paymentDate
        calendarScheduleItem.raw.nextPaid = calendar.nextPaid
        calendarScheduleItem.raw.nextPaymentCard = calendar.nextPaymentCard
        calendarScheduleItem.raw.nextPaymentDate = calendar.nextPaymentDate
        calendarScheduleItem.raw.nextRecurringLabel = calendar.nextRecurringLabel
        calendarScheduleItem.raw.nextStartDate = calendar.nextStartDate
        calendarScheduleItem.raw.nextCreated = calendar.nextCreated
        calendarScheduleItem.raw.canRefund = calendar.canRefund
        calendarScheduleItem.raw.shiftType = calendar.reservation.shift.type
        calendarScheduleItem.raw.fake = calendar.reservation.fake
        calendarScheduleItem.raw.showSubscriptionDetail = !(calendar.recurringLabel === '-' && (['pending', 'booking'].includes(calendar.reservation.status)))
        calendarScheduleItem.raw.customerType = calendar.reservation.customerType
        calendarScheduleItem.raw.clipboardReservation = calendar.clipboardReservation || ''
        calendarScheduleItem.raw.clipboardBooking = calendar.clipboardBooking || ''
        calendarScheduleItem.customStyle = 'border-width: 2px;'

        switch (calendar.status) {
          case 'reserved':
            calendarScheduleItem.bgColor = '#D5D6DB'
            calendarScheduleItem.borderColor = '#D5D6DB'
            break
          case 'booking':
            calendarScheduleItem.bgColor = '#A9C4FF'
            calendarScheduleItem.borderColor = '#A9C4FF'
            calendarScheduleItem.raw.numberOfAcceptCandidates = calendar.badge
            calendarScheduleItem.raw.bookingCard = calendar.bookingCard
            calendarScheduleItem.raw.bookingId = calendar.booking.id
            break
          case 'matched':
            calendarScheduleItem.bgColor = '#5489FF'
            calendarScheduleItem.borderColor = '#5489FF'
            calendarScheduleItem.raw.bookingCard = calendar.bookingCard
            calendarScheduleItem.raw.bookingId = calendar.booking.id
            break
        }

        if (calendar.reservation.fake) {
          calendarScheduleItem.bgColor = '#FFD0D0'
          calendarScheduleItem.borderColor = '#FFD0D0'
        }

        return calendarScheduleItem
      })
  }
}

export function createDateRangeFromDates (dates) {
  let result = []
  let current
  let startDay
  let endDay
  dates = dates.sort(function (a, b) {
    return moment(a) - moment(b)
  })

  for (let i = 0; i < dates.length; i++) {
    current = moment(dates[i])
    if (startDay === undefined) {
      startDay = current
      endDay = current
    } else {
      const nextDay = moment(endDay.format()).add(1, 'days')
      if (nextDay.isSame(current, 'day')) {
        endDay = current
      } else {
        result.push({
          start: startDay.format(),
          end: endDay.format(),
          length: endDay.diff(startDay, 'days') + 1,
        })
        startDay = current
        endDay = current
      }
    }
  }
  if (startDay !== undefined) {
    result.push({
      start: startDay.format(),
      end: endDay.format(),
      length: endDay.diff(startDay, 'days') + 1,
    })
  }
  return result
}
